<div class="prep">
  <andor-app-update-notice />
  <andor-trial-notice />
  <!--  <header class="prep__header">-->
  <!--    <img-->
  <!--      class="prep__logo"-->
  <!--      src="{{ (appConfigStore.getAsset$(userSettingsStore.colorMode + 'Logo') | async)?.url }}"-->
  <!--      crossorigin="anonymous" />-->
  <!--    <span class="prep__room-name">#testRoom</span>-->
  <!--  </header>-->

  <div class="prep__body">
    <div class="prep__video-col">
      <div class="prep__video-wrapper">
        @if (!camStream()) {
          <div class="prep__video-off">
            <fa-duotone-icon [icon]="faVideoSlash" class="prep__off-icon"></fa-duotone-icon>
            <span>{{ 'Camera is off' | translate }}</span>
          </div>
        } @else if (
          permissions.cameraAccess() === 'prompt' || permissions.cameraAccess() === null
        ) {
          <div class="prep__video-skeleton">
            <fa-duotone-icon [icon]="faVideo" class="prep__skeleton-icon"></fa-duotone-icon>
            <span>{{ 'Camera preview' | translate }}</span>
          </div>
        } @else {
          <div class="prep__video-live">
            <div class="prep__live-badge">
              <span class="prep__live-dot"></span>
              Live
            </div>
            @if (camStream() | nativeVideo) {
              <canvas class="prep__video-element" [andorVideoMount]="camStream()"></canvas>
            } @else {
              <video
                [srcObject]="camStream()"
                class="prep__video-element"
                preload="none"
                autoplay
                playsinline
                disablePictureInPicture
                [disableRemotePlayback]="true"
                controlsList="noplaybackrate nodownload"
                muted></video>
            }
          </div>
        }

        <div class="prep__media-bar">
          <andor-split-toggle-button
            [active]="micActive()"
            [disabled]="permissions.microphoneAccess() !== 'granted'"
            [tooltip]="'Toggle microphone' | translate"
            [popoverTitle]="'Input Device'"
            [options]="(deviceService.audioInputDeviceOptions$ | async) ?? []"
            [selectedOptionId]="(deviceService.activeAudioInputDeviceOption$ | async)?.id ?? null"
            (toggleClicked)="toggleMic()"
            (optionSelected)="deviceService.selectAudioInputDeviceById($event.id)">
            <andor-volume-icon [level]="volumeGatePercent()">
              <fa-duotone-icon
                [icon]="micActive() ? faMicrophone : faMicrophoneSlash"></fa-duotone-icon>
            </andor-volume-icon>
          </andor-split-toggle-button>

          <andor-split-toggle-button
            [active]="!!camStream()"
            [disabled]="permissions.cameraAccess() !== 'granted'"
            [tooltip]="'Toggle camera' | translate"
            [popoverTitle]="'Camera'"
            [options]="(deviceService.videoDeviceOptions$ | async) ?? []"
            [selectedOptionId]="(deviceService.selectedVideoDevice$ | async)?.id ?? null"
            (toggleClicked)="toggleCam()"
            (optionSelected)="deviceService.selectVideoDevice($event.id)">
            <fa-duotone-icon [icon]="camStream() ? faVideo : faVideoSlash"></fa-duotone-icon>
          </andor-split-toggle-button>
        </div>
      </div>
    </div>

    <div class="prep__settings-col">
      @if (pendingApproval()) {
        <div class="prep__connecting">
          <andor-join-approval-overlay />
        </div>
      } @else if (connectionError(); as error) {
        <div class="prep__connection-error">
          <fa-duotone-icon
            [icon]="faTriangleExclamation"
            class="prep__error-icon"></fa-duotone-icon>
          <p class="prep__error-reason">{{ error.reason }}</p>

          <!-- The invited room doesn't exist in the registry: offer the same
               room autocomplete as the room-login screen so the user can pick a
               real room instead of being stuck on the error. Picking one clears
               the error and resumes the normal prep flow. -->
          @if (roomState() === 'unknown') {
            <div class="prep__room-picker">
              <p class="prep__picker-hint">
                {{ 'Choose an available room instead:' | translate }}
              </p>
              <andor-autocomplete-field
                class="prep__room-field"
                [label]="'Room' | translate"
                [placeholder]="'Search rooms…' | translate"
                [items]="filteredRooms()"
                [displayWith]="displayRoom"
                [itemKey]="roomKey"
                [emptyText]="'No rooms available' | translate"
                (queryChange)="onRoomQuery($event)"
                (selected)="pickRoom($event)">
                <ng-template #option let-room>
                  <span class="room-option">
                    <span class="room-option__name">{{ room.name }}</span>
                    <span class="room-option__meta">
                      @if (room.isPrivate) {
                        <fa-icon [icon]="faLock" [andorTooltip]="'Private' | translate"></fa-icon>
                      }
                      @if (room.hasPassword) {
                        <fa-icon
                          [icon]="faKey"
                          [andorTooltip]="'Password protected' | translate"></fa-icon>
                      }
                      <span class="room-option__count">
                        {{ room.memberCount }}
                        <span>{{ 'online' | translate }}</span>
                      </span>
                    </span>
                  </span>
                </ng-template>
              </andor-autocomplete-field>
            </div>
          }

          <div class="prep__error-actions">
            @if (error.allowRetry) {
              <button class="prep__error-btn prep__error-btn--primary" (click)="retry()">
                {{ 'Retry' | translate }}
              </button>
              <button class="prep__error-btn prep__error-btn--primary" (click)="retry(true)">
                {{ 'Retry (Always WebRTC)' | translate }}
              </button>
              <button class="prep__error-btn prep__error-btn--muted" (click)="cancel()">
                {{ 'Cancel' | translate }}
              </button>
            } @else {
              <button class="prep__error-btn" (click)="cancel()">
                {{ 'Back' | translate }}
              </button>
            }
          </div>
        </div>
      } @else if (connecting()) {
        <div class="prep__connecting">
          <mat-spinner diameter="32"></mat-spinner>
          <span class="prep__connecting-label">{{ 'Connecting...' | translate }}</span>
          <button class="prep__error-btn prep__error-btn--muted" (click)="cancel()">
            {{ 'Cancel' | translate }}
          </button>
        </div>
      } @else if (noPublicRooms()) {
        <!-- The invited room is gone and there are no other rooms to join (e.g.
             every room was deleted server-side). Show a friendly empty state;
             manageRooms holders get a create CTA, everyone else gets guidance. -->
        <div class="prep__empty-rooms">
          <fa-duotone-icon [icon]="faDoorClosed" class="prep__empty-icon"></fa-duotone-icon>
          <h3 class="prep__empty-title">{{ "It's quiet in here" | translate }}</h3>
          @if (canManageRooms()) {
            <p class="prep__empty-text">
              {{ 'There are no public rooms yet — want to get things started?' | translate }}
            </p>
            <button class="prep__join-btn" [disabled]="trial.expired()" (click)="createRoom()">
              {{ 'Create a room' | translate }}
            </button>
          } @else {
            <p class="prep__empty-text">
              {{
                'There aren’t any public rooms at the moment. To open one, sign in with a role that has the Manage Rooms permission.'
                  | translate
              }}
            </p>
          }
        </div>
      } @else {
        <div class="prep__settings-scroll">
          @if (
            !permissionsDismissed() &&
            permissions.microphoneAccess() !== 'granted' &&
            permissions.cameraAccess() !== 'granted'
          ) {
            <div class="prep__permissions-prompt">
              <fa-duotone-icon [icon]="faHeadset" class="prep__prompt-icon"></fa-duotone-icon>
              <p>
                {{
                  'Grant access to your microphone and camera for the best experience.' | translate
                }}
              </p>
              <div class="prep__permission-choices">
                <button class="prep__grant-btn prep__grant-btn--primary" (click)="requestBoth()">
                  {{ 'Microphone & Camera' | translate }}
                </button>
                <button class="prep__grant-btn" (click)="requestMic()">
                  {{ 'Microphone Only' | translate }}
                </button>
                <button
                  class="prep__grant-btn prep__grant-btn--muted"
                  (click)="dismissPermissions()">
                  {{ 'Listen Only' | translate }}
                </button>
              </div>
            </div>
          }

          <div class="prep__name-group">
            <div
              class="prep__name-field"
              [class.invalid]="userNameControl.invalid && userNameControl.touched"
              [class.pulse]="userNameControl.invalid">
              <fa-duotone-icon [icon]="faUser" class="prep__name-icon"></fa-duotone-icon>
              <input
                class="prep__name-input"
                type="text"
                [placeholder]="'Enter your name' | translate"
                [formControl]="userNameControl" />
            </div>
            @if (userNameControl.invalid && userNameControl.touched) {
              <div class="prep__name-error">
                @if (userNameControl.hasError('required')) {
                  {{ 'Name is required' | translate }}
                } @else if (userNameControl.hasError('minlength')) {
                  {{ 'Name must be at least 3 characters' | translate }}
                } @else if (userNameControl.hasError('maxlength')) {
                  {{ 'Name must not exceed 50 characters' | translate }}
                } @else if (userNameControl.hasError('pattern')) {
                  {{ 'Name must not contain numbers' | translate }}
                }
              </div>
            }
          </div>

          @if (roomSchedule(); as schedule) {
            <div class="prep__schedule">
              <andor-schedule-display [schedule]="schedule" />
            </div>
          }

          @if (
            permissions.microphoneAccess() === 'granted' ||
            permissions.microphoneAccess() === 'unknown'
          ) {
            <andor-expansion-panel
              [icon]="faMicrophone"
              [expanded]="expandedPanel() === 'audio'"
              (expandedChange)="expandedPanel.set($event ? 'audio' : null)">
              <span panel-title class="prep__panel-device-name">
                {{ (deviceService.activeAudioInputDeviceOption$ | async)?.name }}
              </span>

              @if (deviceService.audioInputDeviceOptions$ | async; as audioInputDevices) {
                <andor-select-field
                  [title]="'Microphone' | translate"
                  [options]="audioInputDevices"
                  [selectedOption]="deviceService.activeAudioInputDeviceOption$ | async"
                  (selected)="
                    deviceService.selectAudioInputDeviceById($event.id)
                  "></andor-select-field>
              }

              @if (deviceService.audioOutputDeviceOptions$ | async; as audioOutputDevices) {
                <andor-select-field
                  [title]="'Speaker' | translate"
                  [options]="audioOutputDevices"
                  [selectedOption]="deviceService.activeAudioOutputDeviceOption$ | async"
                  [forceDisabled]="!deviceService.audioOutputSelectionSupported"
                  [infoTooltip]="
                    deviceService.audioOutputSelectionSupported
                      ? ''
                      : ('Your browser doesn\'t support selecting the audio output device. Change it in your operating system or browser settings instead.'
                        | translate)
                  "
                  (selected)="
                    deviceService.selectAudioOutputDeviceById($event.id)
                  "></andor-select-field>
              }

              <andor-mat-slider-wrapper
                label="{{ 'Volume Gate' | translate }}"
                [value]="volumeGatePercent()"
                tooltipText="{{
                  'Measures the volume of the input audio signal in dBFS, thus deciding when you are speaking loud enough to transmit voice data.'
                    | translate
                }}">
                <mat-slider
                  [max]="volumeGateMax"
                  [min]="volumeGateMin"
                  [step]="1"
                  discrete
                  [displayWith]="formatDBFS">
                  <input
                    matSliderThumb
                    (valueChange)="updateVolumeGate($event)"
                    [ngModel]="volumeGate()" />
                </mat-slider>
              </andor-mat-slider-wrapper>
            </andor-expansion-panel>
          } @else if (permissionsDismissed() || permissions.cameraAccess() === 'granted') {
            <button
              class="prep__request-access-btn"
              [class.highlight]="highlightMicAccess()"
              (click)="requestMic()">
              <fa-duotone-icon [icon]="faMicrophone"></fa-duotone-icon>
              {{ 'Enable Microphone' | translate }}
            </button>
          }

          @if (
            permissions.cameraAccess() === 'granted' || permissions.cameraAccess() === 'unknown'
          ) {
            <andor-expansion-panel
              [icon]="faCameraWeb"
              [expanded]="expandedPanel() === 'video'"
              (expandedChange)="expandedPanel.set($event ? 'video' : null)">
              <span panel-title class="prep__panel-device-name">
                {{ (deviceService.selectedVideoDevice$ | async)?.name }}
              </span>

              @if (deviceService.videoDeviceOptions$ | async; as videoDevices) {
                <andor-select-field
                  [title]="'Camera' | translate"
                  [options]="videoDevices"
                  [selectedOption]="deviceService.selectedVideoDevice$ | async"
                  (selected)="deviceService.selectVideoDevice($event.id)"></andor-select-field>
              }

              @if (!blurAvailable) {
                <p class="prep__empty-text">
                  {{ 'Background blur is not available in the app yet.' | translate }}
                </p>
              } @else {
                <andor-mat-toggle-wrapper
                  label="{{ 'Background Blur' | translate }}"
                  tooltipText="{{
                    'Blur your background to keep the focus on you and reduce visual distractions during calls.'
                      | translate
                  }}">
                  <mat-slide-toggle
                    (toggleChange)="updateBackgroundBlurEnabled()"
                    [checked]="backgroundBlurEnabled()"></mat-slide-toggle>
                </andor-mat-toggle-wrapper>

                @if (backgroundBlurEnabled()) {
                  <andor-mat-slider-wrapper
                    label="{{ 'Blur Intensity' | translate }}"
                    tooltipText="{{
                      'Adjust how strongly your background is blurred. A higher value creates a more pronounced effect.'
                        | translate
                    }}">
                    <mat-slider [max]="30" [min]="1" [step]="1" discrete>
                      <input
                        matSliderThumb
                        (valueChange)="updateBackgroundBlurAmount($event)"
                        [ngModel]="backgroundBlurAmount()" />
                    </mat-slider>
                  </andor-mat-slider-wrapper>
                }
              }
            </andor-expansion-panel>
          } @else if (permissionsDismissed() || permissions.microphoneAccess() === 'granted') {
            <button
              class="prep__request-access-btn"
              [class.highlight]="highlightCamAccess()"
              (click)="requestCam()">
              <fa-duotone-icon [icon]="faCameraWeb"></fa-duotone-icon>
              {{ 'Enable Camera' | translate }}
            </button>
          }

          <!-- Invited users join an EXISTING room, so the password field is only
               relevant when the registry says the room exists AND requires a
               password AND no password was preset from the invite link. That is
               exactly the 'known-with-password' room state; the creator toggle /
               preset-from-link variants of the panel don't apply here. -->
          @if (roomState() === 'known-with-password') {
            <andor-e2e-encryption-panel [roomName]="roomId()" />
          }
        </div>

        <div class="prep__actions">
          <button class="prep__join-btn" [disabled]="isJoinDisabled()" (click)="join()">
            {{ joinButtonLabel() | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
